import { useTranslation } from '../useTranslation';

const Apropos = () => {
    const { t } = useTranslation();

  return (
    <>
     <style>{`
    body {
      background: #0c0b09;
    }
  `}</style>

    <section id="about" class="about">
      <div class="container" data-aos="fade-up">

        <div class="row">
          <div class="col-lg-6 order-1 order-lg-2" data-aos="zoom-in" data-aos-delay="100">
            <div class="about-img">
              <img src="assets/img/about.jpg" alt=""/>
            </div>
          </div>
          <div className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content">
  <h3>{t('homeSectionTitle')}</h3>
  <p className="fst-italic">
    {t('homeSectionDescription')}
  </p>
  <ul>
    <li><i className="bi bi-check-circle"></i> {t('homeFeature1')}</li>
    <li><i className="bi bi-check-circle"></i> {t('homeFeature2')}</li>
    <li><i className="bi bi-check-circle"></i> {t('homeFeature3')}</li>
  </ul>
  <p>
    {t('homeSectionConclusion')}
  </p>
</div>
        </div>
      </div>
    </section>
    
    <section id="why-us" class="why-us">
      <div className="container" data-aos="fade-up">
      
      <div className="section-title">
        <h2>{t('whyUsTitle')}</h2>
        <p>{t('whyUsSubtitle')}</p>
      </div>

      <div className="row">
        <div className="col-lg-4">
          <div className="box" data-aos="zoom-in" data-aos-delay="100">
            <span>01</span>
            <h4>{t('whyUsFeature1Title')}</h4>
            <p>{t('whyUsFeature1Desc')}</p>
          </div>
        </div>

        <div className="col-lg-4 mt-4 mt-lg-0">
          <div className="box" data-aos="zoom-in" data-aos-delay="200">
            <span>02</span>
            <h4>{t('whyUsFeature2Title')}</h4>
            <p>{t('whyUsFeature2Desc')}</p>
          </div>
        </div>

        <div className="col-lg-4 mt-4 mt-lg-0">
          <div className="box" data-aos="zoom-in" data-aos-delay="300">
            <span>03</span>
            <h4>{t('whyUsFeature3Title')}</h4>
            <p>{t('whyUsFeature3Desc')}</p>
          </div>
        </div>

      </div>

    </div>
    </section>
    </>
  );
};

export default Apropos;
